import { switchLayout } from '../../actions/sceneActions'
import { GET_SCENES, UPDATE_SCENES, ACTIVE_SCENE, UPDATE_LAYOUT, DELETE_SCENE_CONTENT_KEY, STUDIO_DELETE_SCENE_KEY, STUDIO_SAVE_DISPLAY_WALL_KEY, STUDIO_SAVE_LINK_WALL_KEY, STUDIO_SAVE_SHORT_CODE_KEY, STUDIO_CREATE_NEW_SCENE, STUDIO_UPDATE_EMBED_SHORT_CODE_KEY, STUDIO_SCENE_RE_ORDER_KEY, STUDIO_SCENE_DUPLICATE, STUDIO_SCENE_CONTENT_UPDATE_DURATION, STUDIO_GET_SHORT_CODE_DATA_FOR_UPDATE, STUDIO_GET_URL_DATA_FOR_UPDATE, STUDIO_SAVE_IMAGE_KEY, STUDIO_UPDATE_URL_KEY, STUDIO_GET_MEDIA_DATA_FOR_UPDATE, STUDIO_UPDATE_IMAGE_KEY, UPDATE_EXPANDED_ACCORDION, UPDATE_SCENE_NAME, UPDATE_SCENE_HEIGHT, STUDIO_SAVE_APP, STUDIO_UPDATE_COUNTER, STUDIO_UPDATE_QRCODE, STUDIO_UPDATE_NOTICEBOARD, STUDIO_UPDATE_MOTIVATIONAL_QUOTES, STUDIO_SAVE_UPDATE_APP, STUDIO_UPDATE_CLOCK, STUDIO_UPDATE_CALENDAR, STUDIO_UPDATE_WEATHER_APP, STUDIO_SCENE_CONTENT_UPDATE_ORDER, UPDATE_STUDIO_SCENE_STATUS, STUDIO_UPDATE_LEADERBOARD_APP } from '../keys'


const initialState = { scenes: [], defaultScene: 0, updateSceneData: {}, defaultExpandedKey: "0", feedList: [] }
export default function reducer(state = initialState, action) {
    
    switch (action.type) { 
        
        case GET_SCENES: {
            return { ...state, scenes: action.payload, feedList: action.feedList }
        }
        case ACTIVE_SCENE: {
            return { ...state, defaultScene: action.payload }
        }
        case UPDATE_EXPANDED_ACCORDION: {
            return { ...state, defaultExpandedKey: action.payload }
        }
        case UPDATE_SCENE_HEIGHT: {
            let { scenes } = state;
            const { sceneID, css } = action.payload;
            scenes = updateSceneCss(scenes, sceneID, css)
            return { ...state, scenes }
        }
        case UPDATE_STUDIO_SCENE_STATUS: {
            let { scenes } = state;
            const { sceneId, status } = action.payload;
            scenes = updateSceneStatus(scenes, sceneId, status)
            return { ...state, scenes }
        }


        case STUDIO_SCENE_CONTENT_UPDATE_ORDER: {
            let { scenes, defaultScene } = state;
            var updateScenes = scenes;
            const { reorderedItems } = action.payload;
            if (updateScenes && updateScenes.length > 0 && updateScenes[defaultScene]) {
                let scenesData = updateScenes[defaultScene];
                if (scenesData && scenesData.sceneContent && scenesData.sceneContent.length > 0) {
                    scenesData.sceneContent.map((item, sceneContentIndex) => {
                        if (item.data && item.data.length > 0) {
                            let currentData = [];
                            if (reorderedItems && reorderedItems.length > 0) {
                                reorderedItems.map((currentReOrder) => {
                                    item.data.map((currentChange) => {
                                        if (currentChange.id == currentReOrder) {
                                            currentData.push(currentChange);
                                        }

                                    })
                                })
                            }
                            else currentData = item.data;
                            if (currentData && currentData.length == 0) currentData = item.data;
                            scenes[defaultScene].sceneContent[sceneContentIndex].data = currentData;
                        }
                    })
                }
                return { ...state, scenes: updateScenes }
            }
        }
        case UPDATE_SCENE_NAME: {
            let { scenes } = state;
            const { sceneID, title } = action.payload;
            scenes = updateSceneName(scenes, sceneID, title)
            return { ...state, scenes }
        }
        case STUDIO_SAVE_IMAGE_KEY: {
            let { scenes } = state;
            const { sceneContent } = action.payload;
            scenes = addImage(scenes, sceneContent)
            return { ...state, scenes }
        }
        case STUDIO_UPDATE_URL_KEY: {
            let { scenes } = state;
            const { contentMixId, contentId, url, name } = action.payload;
            scenes = updateURL(scenes, contentMixId, contentId, url, name);
            return { ...state, scenes, updateSceneData: {} }
        }

        case STUDIO_UPDATE_IMAGE_KEY: {
            let { scenes } = state;
            const { contentMixId, contentId, postFile, name, previewURL } = action.payload;
            scenes = updateIMAGE(scenes, contentMixId, contentId, postFile, name, previewURL);
            return { ...state, scenes, updateSceneData: {} }
        }

        case STUDIO_UPDATE_EMBED_SHORT_CODE_KEY: {
            let { scenes } = state;
            const { contentMixId, contentId, shortCode } = action.payload;
            scenes = updateShortCode(scenes, contentMixId, contentId, shortCode);
            return { ...state, scenes, updateSceneData: {} }
        }
        case STUDIO_GET_SHORT_CODE_DATA_FOR_UPDATE: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_UPDATE_COUNTER: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_UPDATE_QRCODE: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_UPDATE_CLOCK: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_UPDATE_NOTICEBOARD: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_UPDATE_WEATHER_APP: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_UPDATE_LEADERBOARD_APP: {
            return { ...state, updateSceneData: action.payload }
        }


        case STUDIO_UPDATE_CLOCK: {
            return { ...state, updateSceneData: action.payload }
        }

        case STUDIO_UPDATE_MOTIVATIONAL_QUOTES: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_UPDATE_CALENDAR: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_GET_URL_DATA_FOR_UPDATE: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_GET_MEDIA_DATA_FOR_UPDATE: {
            return { ...state, updateSceneData: action.payload }
        }
        case STUDIO_SCENE_CONTENT_UPDATE_DURATION: {
            let { scenes } = state;
            const { contentId, duration, sceneID } = action.payload;
            scenes = displayUpdateContentDuration(scenes, contentId, duration, sceneID)
            return { ...state, scenes }
        }

        case STUDIO_SCENE_RE_ORDER_KEY: {
            let { scenes } = state;
            const { reorderedItems } = action.payload;
            let scenesData = scenes.filter((item, index) => item.id == reorderedItems[index])
            return { ...state, scenes: scenesData }
        }
        case STUDIO_SCENE_DUPLICATE: {
            let { scenes } = state;
            let newDuplicateScene = duplicateSceneContent(action.payload.scene);
            scenes.push(newDuplicateScene);
            return { ...state, scenes, defaultScene: (scenes.length - 1) }
        }

        case STUDIO_CREATE_NEW_SCENE: {
            let { scenes, defaultScene } = state;
            let newLayout = newAddScene(action.payload.scene)
            scenes.push(newLayout);
            return { ...state, scenes, defaultScene: (scenes.length - 1) }
        }

        case UPDATE_LAYOUT: {
            let { scenes, defaultScene } = state;
            let { updateLayoutID, layouts } = action.payload
            scenes = updateLayout(scenes, defaultScene, updateLayoutID, layouts)
            return { ...state, scenes }
        }
        case STUDIO_DELETE_SCENE_KEY: {
            let { scenes, defaultScene } = state;
            let { sceneID } = action.payload
            scenes = deletedScene(scenes, sceneID, defaultScene);
            return { ...state, scenes, defaultScene: 0 }
        }
        case DELETE_SCENE_CONTENT_KEY: {
            let { scenes, defaultScene } = state;
            let { sceneContentId, sceneID } = action.payload
            scenes = deletedSceneContent(scenes, sceneContentId, sceneID, defaultScene);
            return { ...state, scenes }
        }
        case STUDIO_SAVE_DISPLAY_WALL_KEY: {
            let { scenes, defaultScene } = state;
            const { sceneContent } = action.payload;
            scenes = addDisplayWall(scenes, sceneContent)
            return { ...state, scenes }
        }
        case STUDIO_SAVE_APP: {
            let { scenes } = state;
            const { sceneContent } = action.payload;
            scenes = addStdioApp(scenes, sceneContent)
            return { ...state, scenes }
        }
        case STUDIO_SAVE_UPDATE_APP: {
            let { scenes } = state;
            scenes = addUpdateStdioApp(scenes, action.payload.contentMixId, action.payload.sceneContentId, action.payload.appContent, action.payload.appId)
            return { ...state, scenes }
        }
        case STUDIO_SAVE_SHORT_CODE_KEY: {
            let { scenes, defaultScene } = state;
            const { sceneContent } = action.payload;
            scenes = addDisplayWall(scenes, sceneContent)
            return { ...state, scenes }
        }
        case STUDIO_SAVE_LINK_WALL_KEY: {
            let { scenes } = state;
            const { sceneContent } = action.payload;
            scenes = addDisplayWall(scenes, sceneContent)
            return { ...state, scenes }
        }
        default:
            return { ...state }
    }

}

const updateSceneName = (scene, sceneID, title) => {
    let updatedScene = scene;
    scene.map((item, index) => {
        if (item.id == sceneID) item.name = title;
    })
    return updatedScene;
}

const updateSceneCss = (scene, sceneID, css) => {
    let updatedScene = scene;
    scene.map((item, index) => {
        if (item.id == sceneID) item.css = css;
    })
    return updatedScene;
}

const updateSceneStatus = (scene, sceneId, status) => {
    let updatedScene = scene;
    scene.map((item, index) => {
        if (item.id == sceneId) item.status = status == false ? 0 : 1;
    })
    return updatedScene;
}


const updateShortCode = (scene, contentMixId, contentId, shortCode) => {
    let updatedScene = scene;
    scene.map((item, index) => {
        if (item.id == contentMixId) {
            item.sceneContent.map((sItem, sIndex) => {
                sItem.data.map((dItem, dIndex) => {
                    if (dItem.id == contentId) {
                        updatedScene[index].sceneContent[sIndex].data[dIndex].content = shortCode;

                    }
                })

            })
        }
    })
    return updatedScene;

}
const updateURL = (scene, contentMixId, contentId, url, name) => {
    let updatedScene = scene;
    scene.map((item, index) => {
        if (item.id == contentMixId) {
            item.sceneContent.map((sItem, sIndex) => {
                sItem.data.map((dItem, dIndex) => {
                    if (dItem.id == contentId) {
                        updatedScene[index].sceneContent[sIndex].data[dIndex].content = url;
                        updatedScene[index].sceneContent[sIndex].data[dIndex].name = name;

                    }
                })

            })
        }
    })
    return updatedScene;

}

const updateIMAGE = (scene, contentMixId, contentId, url, name, previewURL) => {
    let updatedScene = scene;
    scene.map((item, index) => {
        if (item.id == contentMixId) {
            item.sceneContent.map((sItem, sIndex) => {
                sItem.data.map((dItem, dIndex) => {
                    if (dItem.id == contentId) {
                        updatedScene[index].sceneContent[sIndex].data[dIndex].content = previewURL;
                        updatedScene[index].sceneContent[sIndex].data[dIndex].name = name;


                    }
                })

            })
        }
    })
    return updatedScene;

}

const displayUpdateContentDuration = (scene, contentId, duration, sceneID) => {
    let updatedScene = scene;
    scene.map((item, index) => {
        if (item.id == sceneID) {
            item.sceneContent.map((sItem, sIndex) => {
                sItem.data.map((dItem, dIndex) => {
                    if (dItem.id == contentId) {
                        updatedScene[index].sceneContent[sIndex].data[dIndex].sceneDuration = duration;

                    }
                })

            })
        }
    })
    updatedScene = getUpdateDuration(updatedScene, sceneID);
    return updatedScene;
}
const getUpdateDuration = (scene, sceneID) => {
    scene.map((item, index) => {
        if (item.id == sceneID) {
            let contentTime = []
            item.sceneContent.map((sItem, sIndex) => {
                let time = 0;
                sItem.data.map((dItem, dIndex) => {
                    time = parseInt(time) + parseInt(dItem.sceneDuration)
                })
                contentTime.push(time)
            })

            let maxTime = contentTime.reduce((p, v) => (p > v ? p : v));

            item.totalTime = maxTime;
        }
    })
    return scene;
}

const duplicateSceneContent = (updatedLayout) => {
    let updateScene = updatedLayout;
    let zones = Object.keys(updateScene.partitions).map((key) => ({ key, name: updateScene.partitions[key] }));
    let sceneContent = [];
    if (zones && zones.length) {
        zones.map((item, index) => {
            if (updateScene.sceneContent[item.key]) {
                sceneContent.push({ name: item.name, data: updateScene.sceneContent[item.key].data })
            }
            else {
                sceneContent.push({ name: item.name, data: [] })
            }
        })
    }
    updateScene.sceneContent = sceneContent;
    return updateScene;
}
const newAddScene = (newLayout) => {
    let zones = Object.keys(newLayout.partitions).map((key) => newLayout.partitions[key]);
    let sceneContent = [];
    if (zones && zones.length) {
        zones.map((item, index) => {
            sceneContent.push({ name: item, data: [] })
        })
    }
    newLayout.sceneContent = sceneContent;
    newLayout.totalTime = 0
    return newLayout;
}

const addDisplayWall = (scenes, sceneContent) => {
    scenes.map((item, sIndex) => {
        if (item && item.id == parseInt(sceneContent.contentMixId)) {
            item.sceneContent.map((sItem, sCIndex) => {
                if (parseInt(sCIndex) + 1 == parseInt(sceneContent.position)) {
                    scenes[sIndex].sceneContent[sCIndex].data.push(sceneContent);
                }
            })
        }
    })
    scenes = getUpdateDuration(scenes, parseInt(sceneContent.contentMixId));
    return scenes;
}

const addStdioApp = (scenes, sceneContent) => {
    scenes.map((item, sIndex) => {
        if (item && item.id == parseInt(sceneContent.contentMixId)) {
            item.sceneContent.map((sItem, sCIndex) => {
                if (parseInt(sCIndex) + 1 == parseInt(sceneContent.position)) {
                    scenes[sIndex].sceneContent[sCIndex].data.push(sceneContent);
                }
            })
        }
    })
    scenes = getUpdateDuration(scenes, parseInt(sceneContent.contentMixId));
    return scenes;
}

const addImage = (scenes, sceneContent) => {
    scenes.map((item, sIndex) => {
        if (item && item.id == parseInt(sceneContent.contentMixId)) {
            item.sceneContent.map((sItem, sCIndex) => {
                if (parseInt(sCIndex) + 1 == parseInt(sceneContent.position)) {
                    scenes[sIndex].sceneContent[sCIndex].data.push(sceneContent);
                }
            })
        }
    })
    scenes = getUpdateDuration(scenes, parseInt(sceneContent.contentMixId));
    return scenes;
}

const deletedScene = (scenes, sceneID, defaultScene) => {
    scenes.map((item, sIndex) => {
        if (item && item.id == sceneID) {
            scenes.splice(sIndex, 1)
        }
    })
    return scenes;
}

const deletedSceneContent = (scenes, sceneContentId, sceneID, defaultScene) => {

    scenes.map((item, sIndex) => {

        if (item && item.id == sceneID) {
            item.sceneContent.map((sItem, sCIndex) => {
                sItem.data.map((deleteItem, index) => {
                    if (deleteItem.id == sceneContentId) {
                        scenes[sIndex].sceneContent[sCIndex].data.splice(index, 1);
                    }

                })

            })

        }
    })
    scenes = getDeleteUpdateDuration(scenes);
    return scenes;
}

const getDeleteUpdateDuration = (scene) => {
    scene.map((item, index) => {
        let contentTime = []
        item.sceneContent.map((sItem, sIndex) => {
            let time = 0;
            sItem.data.map((dItem, dIndex) => {
                time = parseInt(time) + parseInt(dItem.sceneDuration)
            })
            contentTime.push(time)
        })
        let maxTime = contentTime.reduce((p, v) => (p > v ? p : v));
        item.totalTime = maxTime;
    })
    return scene;
}

const updateLayout = (scenes, defaultScene, layoutID, layouts) => {
    let updateScene = scenes;
    const updatedLayout = layouts.filter((item) => item.id == layoutID);
    if (updateScene[defaultScene].mixContentType != updatedLayout[0].id) {
        const alreadyLayout = layouts.filter((item) => item.id == updateScene[defaultScene].mixContentType)
        if (alreadyLayout[0].zone <= updatedLayout[0].zone) {
            updateScene[defaultScene].mixContentType = updatedLayout[0].id;
            updateScene[defaultScene].css = updatedLayout[0].css;
            updateScene[defaultScene].name = updatedLayout[0].name;
            updateScene[defaultScene].partitions = updatedLayout[0].partitions;
            let zones = Object.keys(updatedLayout[0].partitions).map((key) => updatedLayout[0].partitions[key]);
            if (zones && zones.length) {
                zones.map((item, index) => {
                    if (updateScene[defaultScene].sceneContent[index]) {
                        updateScene[defaultScene].sceneContent[index] = { name: item, data: updateScene[defaultScene].sceneContent[index].data }
                    }
                    else {
                        updateScene[defaultScene].sceneContent[index] = { name: item, data: [] }
                    }
                })
            }
            switchLayout(updateScene[defaultScene].id, updatedLayout[0].id);
        }
        else {
            updateScene[defaultScene].mixContentType = updatedLayout[0].id;
            updateScene[defaultScene].css = updatedLayout[0].css;
            updateScene[defaultScene].name = updatedLayout[0].name;
            updateScene[defaultScene].partitions = updatedLayout[0].partitions;
            let zones = Object.keys(updatedLayout[0].partitions).map((key) => updatedLayout[0].partitions[key]);
            let sceneContent = [];
            if (zones && zones.length) {
                zones.map((item, index) => {
                    if (updateScene[defaultScene].sceneContent[index]) {
                        sceneContent.push({ name: item, data: updateScene[defaultScene].sceneContent[index].data })
                    }
                    else {
                        sceneContent.push({ name: item, data: [] })
                    }
                })
            }
            updateScene[defaultScene].sceneContent = sceneContent;
            switchLayout(updateScene[defaultScene].id, updatedLayout[0].id);
        }

    }
    return updateScene
}
const addUpdateStdioApp = (scenes, contentMixId, sceneContentId, appContent, appId) => {
    scenes.map((item, sIndex) => {
        if (item && item.id == contentMixId) {
            item.sceneContent.map((sItem, sCIndex) => {
                sItem.data.map((dItem, dCIndex) => {
                    if (dItem.id == sceneContentId) {
                        // scenes[sIndex].sceneContent[sCIndex].data[dCIndex].app_data = [];
                        scenes[sIndex].sceneContent[sCIndex].data[dCIndex].app_data = appContent;
                        if (dItem.app_id == 8) {
                            scenes[sIndex].sceneContent[sCIndex].data[dCIndex].sceneDuration = parseInt(60 * appContent.timeInterval) > 60 ? parseInt(60 * appContent.timeInterval) : 60;
                        }
                    }
                })
            })
        }
    })
    scenes = getUpdateDuration(scenes, parseInt(contentMixId));
    return scenes;

}